import { Linking } from "react-native";
function openExternalURL(url) {
  Linking.openURL(url);
}
export {
  openExternalURL
};
//# sourceMappingURL=openExternalURL.native.js.map
